import React, { useEffect, useRef, useState } from "react";
import AgreedAndGivenBlockCustom from "./AgreedAndGivenBlockCustom";
import AgreedAndGivenBlockClassic from "./AgreedAndGivenBlockClassic";

const AgreedAndGivenBlockMaster = ({ customReport, data }) => {
  return (
    <div>
      {customReport ? (
        <AgreedAndGivenBlockCustom data={data} />
      ) : (
        <AgreedAndGivenBlockClassic />
      )}
    </div>
  );
};
export default AgreedAndGivenBlockMaster;
